// all API Integration
import { fetchEventSource } from "@microsoft/fetch-event-source";

const API_ENDPOINTS = { 
    TOUCHPOINTS_DATA: "./touchpoints.json",
    CONTRIBUTION_OPTIONS: "./contributionOptions.json",
    DENSITYCOVERAGE_DATA:"./densityCoverage.json",
    PERFORMANCE_CARD_DATA : "./Industry.json",
    LEFT_DEMOGRAPHICS_DATA:"./leftDemographics.json",
    LOCATION_DATA : "./locations.json",
    REGION_DATA : "./demographics.json",
    DISTRICT_DATA : "./Jihomoravsky-district.json",
    RIGHT_DEMOGRAPHICS_DATA: "./rightDemographics.json",
    IQOS_DATA: "./IQOSdata.json",
    geojson: "./geojson.json"
  };
  
  //only for "hlavni-mesto-praha" regions data
export const getTempGeojson = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.geojson);
    if (!response.ok) {
      throw new Error(`${response.status}`);
    }
    const data = await response.json();
    return data;  
  } catch (error) {
    console.error("Error", error);
    throw error;
  }
}

// use fetch 
  export const getMetaData = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");

       const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          credentials: 'include', 
          mode: 'cors',
          redirect: 'follow',
        }
        const response = await fetch("https://store-advisor-backend-dts.dev.ocean.pmicloud.biz/v1/map/metadata", requestOptions);
        if (!response.ok) {
          throw new Error(`${response.status}`);
        }
        const data = await response.json();
        return data;
  };
  
  export const getRegions = async () => {
    try{
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      const raw = JSON.stringify({
        "region_id": "hlavni-mesto-praha"
      });
      
       const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          credentials: 'include', 
          mode: 'cors',
          redirect: 'follow',
          body: raw
        };
        const response = await fetch("https://store-advisor-backend-dts.dev.ocean.pmicloud.biz/v1/map/regions/hlavni-mesto-praha/geojson", requestOptions);
        if (!response.ok) {
          throw new Error(`${response.status}`);
        }
        const data = await response.json();
        return data;
      }catch (error) {
        console.error("Error", error);
        throw error;
      }
  };

export const getTouchpoints = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.TOUCHPOINTS_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      const data = await response.json();
      return  data;  
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };
  
  export const getContributionOptions = async () => {
    try {
      // const response =  await fetchEventSource(API_ENDPOINTS.CONTRIBUTION_OPTIONS, {
      //   onmessage(event) {
      //     const newData = JSON.parse(event.data);
      //     setData((prev) => [...prev, newData]); 
      //   },
      //   onerror(error) {
      //     console.error("error:", error);
      //   },
      // });
      const response = await fetch(API_ENDPOINTS.CONTRIBUTION_OPTIONS);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getDensityCoverage = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.DENSITYCOVERAGE_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };
  
  export const getPerformanceCardData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.PERFORMANCE_CARD_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getLeftDemographicsData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.LEFT_DEMOGRAPHICS_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getRightDemographicsData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.RIGHT_DEMOGRAPHICS_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };
  
  export const getLocationsData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.LOCATION_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getRegionData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.REGION_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getDistrictData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.DISTRICT_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  export const getIQOSData = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.IQOS_DATA);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };